import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-calculated-metrics',
  templateUrl: './help-calculated-metrics.component.html',
  styleUrls: ['./help-calculated-metrics.component.scss']
})
export class HelpCalculatedMetricsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
